import {URLS, interact} from 'fire-wind-water';
import {getCookieId, getVerify, getVerifyInfo, setOpenId, setSession, setVerify, setVerifyInfo} from './cookie';
import {Subject} from 'rxjs';
import {data} from './data';

class Auth {
  code = URLS.getURL('excode');
  wxCode = URLS.getURL('code');
  appid = URLS.getURL('appid');
  weChatId = URLS.getURL('weChatId');
  token = null;
  tokenInfo = null;
  scope: string;

  constructor() {
  }

  returnToken() {
    return new Promise(resolve => {
      resolve({
        token: this.token,
        tokenInfo: this.tokenInfo
      });
    });
  }

  returnWxcode() {
    return new Promise(resolve => {
      this.initWxcode().subscribe(res => {
        resolve(res);
      });
    });
  }

  returnCode() {
    return new Promise(resolve => {
      this.initCode().subscribe(res => {
        resolve(res);
      });
    });
  }

  returnError(): Promise<any> {
    return new Promise(resolve => {
      this.initAuthorization().subscribe(res => {
        resolve(res);
      });
    });
  }

  returnNull(): Promise<any> {
    return new Promise(resolve => {
      resolve({
        token: null,
        tokenInfo: null
      });
    });
  }

  // 'snsapi_base' : 'snsapi_userinfo'
  initAuth(weChatId: string, scope = 'snsapi_base'): Promise<any> {
    // 如果weChatId不存在或者为0，不去走授权逻辑
    if (!weChatId || weChatId === '0') {
      return this.returnNull();
    }
    this.weChatId = weChatId;
    this.scope = scope;
    this.initToken();
    if (this.token && this.tokenInfo) {
      return this.returnToken();
    }
    if (this.wxCode) {
      return this.returnWxcode();
    }
    if (this.code) {
      return this.returnCode();
    }
    return this.returnError();
  }

  initToken(): void {
    this.token = getVerify(this.weChatId);
    this.tokenInfo = getVerifyInfo(this.weChatId);
  }

  initWxcode() {
    const $s = new Subject<any>();
    const info = {
      weChatId: this.weChatId,
      wxCode: this.wxCode,
      appId: this.appid,
      globalUserId: getCookieId()
    };
    data.getWxcode(info).subscribe(res => {
      if(res){
        this.resultContent(res, $s);
      }else{
        this.initAuthorization();
      }
    });
    return $s;
  }

  initCode() {
    const $s = new Subject<any>();
    const info = {
      code: this.code
    };
    data.getCode(info).subscribe(res => {
      if(res){
        this.resultContent(res, $s);
      }else{
        this.initAuthorization();
      }
    });
    return $s;
  }

  initAuthorization() {
    const $s = new Subject<any>();
    const info = {
      weChatId: this.weChatId,
      scope: this.scope
    };
    const key = 'auth';
    data.getOAuth(info).subscribe(res => {
      if(res){
        if (res.canOAuth != 1) {
          $s.next({
            token: null,
            tokenInfo: null
          });
          $s.complete();
          return;
        }
        let loginUrl = res[key];
        let loadcount = parseInt(URLS.getURL('loadcount')) || 0;
        loadcount += 1;
        let zurl = URLS.removeSearchParam(window.location.href, 'code', 'appid', 'loadcount');
        zurl = URLS.updateSearchParam('loadcount', loadcount, zurl);
        loginUrl = URLS.updateSearchParam('return_url', encodeURIComponent(zurl), loginUrl);
        if (info.hasOwnProperty('scope')) {
          loginUrl = URLS.updateSearchParam('scope', info.scope, loginUrl);
        }
        if(loadcount < 4){
          window.location.href = loginUrl;
        }
      }else{
        this.initAuthorization();
      }
    });
    return $s;
  }

  resultContent(data, $s): void {
    this.token = data.token;
    this.tokenInfo = data.tokenInfo;
    setVerify(this.weChatId, this.token);
    setVerifyInfo(this.weChatId, this.tokenInfo);
    setOpenId(this.weChatId, this.tokenInfo.providerId || this.tokenInfo.original.openid);
    if (data.schemaId && data.session) {
      setSession({
        session: data.session,
        memberId: data.memberId
      });
    }
    $s.next({
      token: this.token,
      tokenInfo: this.tokenInfo
    });
    $s.complete();
  }

  init() {
    // 非微信环境下，不走授权
    if (interact.isWeChat) {
      return this.initAuth(this.weChatId);
    } else {
      return this.returnNull();
    }
  }
}

export const auth = new Auth();